import { createContext, useContext } from 'react';

type SideMenuContextValue = {
  overrideSideMenu?(hide: boolean, show: boolean): void;
};

export const SideMenuContext = createContext<SideMenuContextValue | undefined>(
  undefined
);

export const { Provider: SideMenuContextProvider } = SideMenuContext;

export const useSideMenuContext = () => {
  const context = useContext(SideMenuContext);
  if (!context) {
    throw new Error(
      'useSideMenuContext must be used within an SideMenuContextProvider'
    );
  }
  return context;
};
